import { RcClasses } from '../../../../foundation';
import { RcToggleButton } from '../../ToggleButton';
import { RcToggleButtonClasses } from '../../ToggleButton/utils';
export var RcToggleButtonGroupClasses = RcClasses(['groupedHorizontal', 'groupedVertical'], 'RcToggleButtonGroup');
// * Mui will set selected + selected margin order, need reset
export var toggleButtonBetweenClassName = RcToggleButton + "." + RcToggleButtonClasses.selected + " + " + RcToggleButton + "." + RcToggleButtonClasses.selected;
